import { times } from 'lodash';
/**
 * @ngdoc filter
 * @name adjust.filter:range
 *
 * @description
 * Forms the range for the particular value, used with ng-repeat
 *
 * @param {Array} range range to be formed
 * @param {number} total total number of items for the range
 *
 */
function range() {
  'ngInject';
  return function (range, total) {
    total = parseInt(total, 10);

    times(total, function (i) {
      range.push(i);
    });

    return range;
  };
}
export { range };
